import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Science, TouchApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  padding: "4px",
  "& .MuiToggleButton-root": {
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    margin: "0 2px",
    textTransform: "none",
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },
}));

const TestModeSelector = ({ testMode, onModeChange }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
      <StyledToggleButtonGroup
        value={testMode}
        exclusive
        onChange={onModeChange}
        aria-label="test mode"
      >
        <ToggleButton value="device" aria-label="device test">
          <Science sx={{ mr: 1 }} />
          {t("Device Test")}
        </ToggleButton>
        <ToggleButton value="manual" aria-label="manual test">
          <TouchApp sx={{ mr: 1 }} />
          {t("Manual Test")}
        </ToggleButton>
      </StyledToggleButtonGroup>
    </Box>
  );
};

export default TestModeSelector;
